<template>
<div class="isAccepted">
  <div class="projectName">{{ project.name }}</div>
  <div class="bgf">
    <div class="project-info">
      <div class="announcementTitle" v-if="project.oldInfo">澄清后公告：</div>
      <projectInfo :project="project"  :projectId="$route.query.id"  :oldInfo="0"/>
      <div class="announcementTitle" v-if="project.oldInfo">原公告：</div>
      <projectInfo :project="project.oldInfo"  :projectId="$route.query.id"  :oldInfo="1"/>
    </div>
    <div class="button" v-if="acceptFlag === 0">
      <el-button type="warning" @click="refuseSubmit" class="btnHeight_40 btWith_120">拒绝接活</el-button>
      <el-button type="primary" @click="acceptanceSubmit" class="btnHeight_40 btWith_120 mg_left_40">确定接活</el-button>
    </div>
  </div>
</div>
</template>

<script>
import projectInfo from '@views/components/projectInfo'
import { getNormalProjectInfo, getProjectAcceptFlag, refuse, accept } from '@api/project'
export default {
  name: 'isAccepted',
  components: { projectInfo },
  data () {
    return {
      project: {},
      acceptFlag: ''
    }
  },
  created () {
    this.id = this.$route.query.id
    this.getNormalProjectInfo()
    this.getProjectAcceptFlag()
  },
  methods: {
    // 获取项目详情
    getNormalProjectInfo () {
      getNormalProjectInfo({ id: this.$route.query.id }).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
        } else {
          this.message.error(res.data.msg)
        }
      })
    },
    // 获取接活状态
    getProjectAcceptFlag () {
      getProjectAcceptFlag({
        projectId: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.acceptFlag = res.data.data.acceptFlag
        } else {
          this.message.error(res.data.msg)
        }
      })
    },
    refuseSubmit () {
      this.$confirm('拒绝接活，会造成你的信用分扣减，会影响未来投标的成功率，请慎重考虑', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        refuse({
          projectId: this.$route.query.id
        }).then(res => {
          if (res.data.code === 200) {
            this.$message.success('拒绝成功')
            this.getNormalProjectInfo()
            this.getProjectAcceptFlag()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    // 接标
    acceptanceSubmit () {
      accept({
        projectId: this.project.id
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success('接标成功')
          this.getNormalProjectInfo()
          this.getProjectAcceptFlag()
        } else {
          this.message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.isAccepted{
  width: 75%;
  .button{
    width: 280px;
    margin: 0 auto;
  }
}
</style>
